<script>
export default {
    props: ['width', 'bgColor', 'closePopup'],
    data(){
        return {
           areaWidth: this.width == undefined || this.$isMobile ? '80%' : this.width,
           height: $(window).height() - 100 + 'px'
        }
    },
    methods:
    {
        handleChildClick(event) {
            event.stopPropagation(); 
        },
        handleKeyDown(event) {
            if (event.key === "Escape") {
                this.closeP();         
            }
        },
        closeP() {
            if(this.closePopup != undefined)
            {
                this.closePopup();
            }
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }   
}
</script>
<template>
<div class="PopUp-bg" v-fade-in="200" @click="closeP">
    <div class="PopUp-area" :style="{ 'width': areaWidth, 'max-height': height, 'background-color': bgColor }"  @click="handleChildClick">
        <slot></slot> <!-- slot outlet -->
    </div>
</div>
</template>

<style scoped>
    .PopUp-bg
    {
        position: fixed;
        left: 0px;
        top: 0px;
        width:100%;
        height: 100vh;
        background-color: rgba(0,0,0,0.6);
        z-index:1001;
    }

    .PopUp-area
    {
        position: absolute;
        top: 50px;
        width: 80%;
        margin: auto;
        left: 0px;
        right: 0px;
        padding:20px;
        overflow-y: auto;
        border: 1px solid rgba(255, 255, 255, 0.3);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), 0 2px 6px rgba(0, 0, 0, 0.05);
        background-color: hsla(41, 70%, 98%, 0.92);
        backdrop-filter: blur(12px) saturate(150%);
        border-radius: 16px;
    }

    @media only screen and (max-width: 1000px) {
    .PopUp-area
    {
        top: 30px;
    }
}
</style>